import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Educationals from '../components/Educationals';
import Materials from '../components/Materials';
//import Sheets from '../components/Sheets';
import Apps from '../components/Apps';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 20
  }
}));

export default function Links() {

  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [current, setCurrent] = React.useState(0);

  const change = (evt, val) => {
    setCurrent(val);
  }

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={2}
        direction="row"
        alignItems="center"
       justifyContent="center"
      >
        <Grid item xs={12} sm={8}>
          <Tabs
            variant={isMobile ? "scrollable" : "fullWidth"}
            value={current}
            onChange={change}
          >
            <Tab label="Educational" />
            <Tab label="Materials" />
            {/* <Tab label="Music Sheets" />  */}
            <Tab label="Apps" />
          </Tabs>
          {current === 0 && <Educationals />}
          {current === 1 && <Materials />}
          {/* {current === 2 && <Sheets />}*/}
          {current === 2 && <Apps />}
        </Grid>
      </Grid>
    </div>
  )
}
